import { NSTable } from 'bricks';
import { numeralFormatter } from 'ns_libs/formatter';
import { useProFormaSocketContext } from '../../socketContext/ProFormaSocketProvider';
import LotTakedownRow from './LotTakedownRow';
import './ProFormaLotTakedownRate.scss';

const TH_CLASS = 'NSTable__thead__tr__th align-middle py-2 px-3';
const TFOOT_TD_CLASS = 'NSTable__tfoot__tr__td align-middle px-3 py-2';

const ProFormaLotTakedownRate = () => {
    const { proForma, residentialLotMixes, disposition, handleUpdateResidentialLotMix } = useProFormaSocketContext();
    const rows = residentialLotMixes?.residentialLotMixes ?? [];

    const recurringLabel = disposition?.saleFrequency === 'monthly' ? 'Recurring / Mo' : 'Recurring / Qtr';

    const updateTakedown = (lotMixId: number, dataKey: 'initialTake' | 'recurringNum', value: number | null) => {
        if (handleUpdateResidentialLotMix) handleUpdateResidentialLotMix(lotMixId, dataKey, value);
    };

    if (rows.length === 0) {
        return (
            <div className="ProFormaLotTakedownRate m-3 text-muted">
                Add lot sizes on the General Information tab to set the takedown rate.
            </div>
        );
    }

    const totalLots = proForma?.totalLots ?? 0;
    const totalInitialTake = proForma?.totalInitialTake ?? 0;
    const totalRecurring = proForma?.totalRecurringNum ?? 0;

    return (
        <div className="ProFormaLotTakedownRate m-3">
            <NSTable className="NSTable ProFormaLotTakedownRate__table mb-0">
                <thead className="NSTable__thead">
                    <tr className="NSTable__thead__tr">
                        <th className={TH_CLASS}>Lot name</th>
                        <th className={`${TH_CLASS} text-right`}>Lot size (ft)</th>
                        <th className={`${TH_CLASS} text-right`}>Total lots</th>
                        <th className={`${TH_CLASS} text-right`}>Initial take</th>
                        <th className={`${TH_CLASS} text-right`}>{recurringLabel}</th>
                    </tr>
                </thead>
                <tbody className="NSTable__tbody">
                    {rows.map(row => (
                        <LotTakedownRow key={row.id} row={row} onUpdate={updateTakedown} />
                    ))}
                </tbody>
                <tfoot className="NSTable__tfoot">
                    <tr className="NSTable__tfoot__tr">
                        <td className={`${TFOOT_TD_CLASS} text-dark font-weight-bold`}>Total</td>
                        <td className={`${TFOOT_TD_CLASS} text-right`} />
                        <td className={`${TFOOT_TD_CLASS} text-right text-dark font-weight-bold`}>
                            {numeralFormatter(totalLots, '0,0')}
                        </td>
                        <td className={`${TFOOT_TD_CLASS} text-right text-dark font-weight-bold`}>
                            {numeralFormatter(totalInitialTake, '0,0')}
                        </td>
                        <td className={`${TFOOT_TD_CLASS} text-right text-dark font-weight-bold`}>
                            {numeralFormatter(totalRecurring, '0,0')}
                        </td>
                    </tr>
                </tfoot>
            </NSTable>
        </div>
    );
};

export default ProFormaLotTakedownRate;
